import { v4 as uuidv4 } from 'uuid';
import { getItem } from './storage';

export const getSessionId = () =>
  getItem<string>('local', 'anonymous-session-id', uuidv4());
